import React from 'react';

import { ReactComponent as Icon } from '../../../assets/question.svg';

export const QuestionIcon = ({size, color}) => {
    return (
        <Icon alt="question icon" className="question_icon" style={{ width: size + 'px', fill: color }} />
    );
};